import axios from 'axios'

/**
 * Product tab of the New Project modal: ask the backend to draft a script from a
 * product image, or from an Amazon / Walmart product link. (POR-14138)
 *
 * Returns `{ text, imageUrl }` — the script the user is about to review in the
 * Script tab, and the product image already persisted the same way an image
 * dropped into the editor is, ready to be inserted.
 *
 * `sceneCount` is the modal's Scenes picker (Auto, 1, 2, 3, 4, 5, 6, 8) — a falsy
 * value ("Auto") is left off the request entirely, which asks the backend for
 * the 3-4 scenes the tab promises.
 *
 * `description` is AI Studio's "Create a video" (POR-14827): the user's own words
 * about the video, drafted into a script with no image (`imageUrl` comes back empty).
 */
export const draftScript = async ({ file, productUrl, description, sceneCount }) => {
  const body = new FormData()

  if (file) {
    body.append('image', file)
  } else if (description) {
    body.append('description', description)
  } else {
    body.append('product_url', productUrl)
  }

  if (sceneCount) {
    body.append('scene_count', sceneCount)
  }

  const { data } = await axios.post('/video/script-draft', body)

  return {
    text: data.text || '',
    imageUrl: data.image_url || '',
  }
}
